import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AccessLayoutComponent } from './access-layout.component';

@NgModule({
  declarations: [
    AccessLayoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ]
})
export class AccessLayoutModule { }
